// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import { Turbo } from "@hotwired/turbo-rails";
Turbo.session.drive = false; // Disable Turbo Drive globally
import { Application, Controller } from "@hotwired/stimulus";
import StimulusReflex from "stimulus_reflex";
import { createConsumer } from "@rails/actioncable";
// CropperJS CSS is imported in application.css

// Import controllers
import ApplicationController from "./controllers/application_controller";
// import CollectionManagerController from "./controllers/collection_manager_controller";
import ConciergeController from "./controllers/concierge_controller";
import CropperController from "./controllers/cropper_controller";
import DropdownController from "./controllers/dropdown_controller";
import ModalController from "./controllers/modal_controller";
import NavController from "./controllers/nav_controller";
import SelectController from "./controllers/select_controller";

import WineManagerController from "./controllers/wine_manager_controller";
import WineRegionController from "./controllers/wine_region_controller";
// import VintageManagerController from "./controllers/vintage_manager_controller";
import VintageToggleController from "./controllers/vintage_toggle_controller";
import VintageVarietiesController from "./controllers/vintage_varieties_controller";
import VintageFlavourizerController from "./controllers/vintage_flavourizer_controller";
import CopyButtonController from "./controllers/copy_button_controller";
import CompetitionFormController from "./controllers/competition_form_controller";
import WineriesController from "./controllers/wineries_controller";
import VenueController from "./controllers/venue_controller";
import WinesController from "./controllers/wines_controller";
import RateableSelectController from "./controllers/rateable_select_controller";

import OrganizationSearchController from "./controllers/organization_search_controller";

import CountryLocationSearchController from "./controllers/country_location_search_controller";
import SubdivisionLocationSearchController from "./controllers/subdivision_location_search_controller";
import OrganizationLocationSearchController from "./controllers/organization_location_search_controller";
import OrganizationCountrySearchController from "./controllers/organization_country_search_controller";
console.log(
  "OrganizationCountrySearchController registered",
  OrganizationCountrySearchController,
);

import WineSearchController from "./controllers/wine_search_controller";
import OrganizationFormSearchController from "./controllers/organization_form_search_controller";
import LocationFormSearchController from "./controllers/location_form_search_controller";
import AuthorityFormSearchController from "./controllers/authority_form_search_controller";
import TeamMembershipOrganizationSearchController from "./controllers/team_membership_organization_search_controller";
import AppellationSearchController from "./controllers/appellation_search_controller";
import AppellationFormSearchController from "./controllers/appellation_form_search_controller";
import AppellationToggleController from "./controllers/appellation_toggle_controller";
import CollectionSearchController from "./controllers/collection_search_controller";
import PublicWineVarietiesController from "./controllers/public_wine_varieties_controller";
import PublicWineFormController from "./controllers/public_wine_form_controller";
import OrganizationWineEntryFormController from "./controllers/organization_wine_entry_form_controller";
import OrganizationWineVarietiesController from "./controllers/organization_wine_varieties_controller";
import OrganizationsController from "./controllers/organizations_controller";
import VarietyDonutChartController from "./controllers/variety_donut_chart_controller";
import AttachmentDropdownController from "./controllers/attachment_dropdown_controller";
import AttachmentsController from "./controllers/attachments_controller";
import AttachmentCropperController from "./controllers/attachment_cropper_controller";
import AttachmentProcessorController from "./controllers/attachment_processor_controller";
import CarouselController from "./controllers/carousel_controller";
import SimpleS3UploadController from "./controllers/simple_s3_upload_controller";
import GooglePlacesController from "./controllers/google_places_controller";
import CountrySearchController from "./controllers/country_search_controller";
import SubdivisionSearchController from "./controllers/subdivision_search_controller";
import StripeSubscriptionController from "./controllers/stripe_subscription_controller";

console.log("application.js loaded - UPDATED!");

// Initialize Stimulus
const application = Application.start();

// Configure Stimulus development experience
application.debug = true; // Enable debug mode

// Initialize StimulusReflex
const consumer = createConsumer();
StimulusReflex.initialize(application, { consumer });
// alert("StimulusReflex initialized");

// Register controllers
application.register("application", ApplicationController);
// application.register("collection-manager", CollectionManagerController);
application.register("concierge", ConciergeController);
application.register("cropper", CropperController);
application.register("dropdown", DropdownController);
application.register("modal", ModalController);
application.register("nav", NavController);
application.register("select", SelectController);

application.register("wine-manager", WineManagerController);
application.register("wine-region", WineRegionController);
application.register("vintage-toggle", VintageToggleController);
application.register("vintage-varieties", VintageVarietiesController);
application.register("vintage-flavourizer", VintageFlavourizerController);
application.register("copy-button", CopyButtonController);
application.register("competition-form", CompetitionFormController);
application.register("wineries", WineriesController);
application.register("venue", VenueController);
application.register("wines", WinesController);
application.register("rateable-select", RateableSelectController);
application.register("organization-search", OrganizationSearchController);
application.register(
  "organization-location-search",
  OrganizationLocationSearchController,
);
application.register(
  "organization-country-search",
  OrganizationCountrySearchController,
);
application.register(
  "country-location-search",
  CountryLocationSearchController,
);

console.log(
  "OrganizationCountrySearchController registeredddddddd",
  OrganizationCountrySearchController,
);
application.register(
  "subdivision-location-search",
  SubdivisionLocationSearchController,
);

application.register("wine-search", WineSearchController);
application.register(
  "organization-form-search",
  OrganizationFormSearchController,
);
// application.register("location-form-search", LocationFormSearchController);
application.register("authority-form-search", AuthorityFormSearchController);
application.register(
  "team-membership-organization-search",
  TeamMembershipOrganizationSearchController,
);
application.register("appellation-search", AppellationSearchController);
application.register(
  "appellation-form-search",
  AppellationFormSearchController,
);
application.register("appellation-toggle", AppellationToggleController);
application.register("collection-search", CollectionSearchController);
application.register("public-wine-varieties", PublicWineVarietiesController);
application.register("public-wine-form", PublicWineFormController);
application.register(
  "organization-wine-entry-form",
  OrganizationWineEntryFormController,
);
application.register(
  "organization-wine-varieties",
  OrganizationWineVarietiesController,
);
application.register("organizations", OrganizationsController);
application.register("variety-donut-chart", VarietyDonutChartController);
application.register("attachment-dropdown", AttachmentDropdownController);
application.register("attachments", AttachmentsController);
application.register("attachment-cropper", AttachmentCropperController);
application.register("attachment-processor", AttachmentProcessorController);
application.register("carousel", CarouselController);
application.register("simple-s3-upload", SimpleS3UploadController);
application.register("google-places", GooglePlacesController);
application.register("country-search", CountrySearchController);
application.register("subdivision-search", SubdivisionSearchController);
application.register("stripe-subscription", StripeSubscriptionController);

console.log("Controller registration completenesssss");

export { application };
